module.exports = __webpack_public_path__ + "img/Zeppa_e_Intersuola_SX.7d71697a.png";